import { render, staticRenderFns } from "./ResultadosPorCentroCosto.vue?vue&type=template&id=920d1b52&"
import script from "./ResultadosPorCentroCosto.vue?vue&type=script&lang=js&"
export * from "./ResultadosPorCentroCosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports